export default __webpack_public_path__ + "static/media/USDC.c4477cfc.png";